import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';
const environment = import.meta.env.MODE;

export default {
    originalImageKey: 'ai/input/image-enhancer/',
    resultImageKey: 'ai/export/image-enhancer/',
    historyListType: 5,
    freeLimitType: 'image-enhancer',
    currentMenuName: 'ai-image-upscaler',
    notImageBoxBgUrl:
        environment === LOCAL
            ? `/public/img/imageEnhancer/bg.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/imageEnhancer/bg.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/img/imageEnhancer/video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/imageEnhancer/video.mp4?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxTitle: 'upscale-images-for-stunning-visuals',
    notImageBoxDesc: 'increase-image-resolution-in-batches-to-achieve-high-resolution-results',
};
